import React, { Component } from "react";
import { toFixed, GET, loading, Navbar, params } from "../../components/CustomComponent.js";
import LOGOLARGE from "../../assets/images/logo512.png";
import HERO_BG from "../../assets/images/warehouse.jpg";
import Footer from "../../components/Footer.js";

const count_per_page = 24;
// หมวดหมู่: ถ้ามีรายการมากกว่านี้ให้แสดงเป็น 2 แถว
const CATEGORY_TWO_ROWS_MIN = 8;

// ขายดีประจำสัปดาห์: จำนวนสินค้า และจำนวนหน้าที่หมุนเวียนจากสินค้าราคาถูกสุด
const TOP_SALE_SIZE = 20;
const TOP_SALE_ROTATE_PAGES = 3;
const TOP_SALE_SCROLL_STEP = 6; // กดลูกศรแล้วเลื่อนทีละกี่ชิ้น

// สัปดาห์ที่เท่าไรของปี ใช้เป็น seed ให้ยอดขายคงที่ทั้งสัปดาห์และเปลี่ยนเมื่อขึ้นสัปดาห์ใหม่
const getWeekOfYear = () => {
  const now = new Date();
  const startDate = new Date(now.getFullYear(), 0, 1);
  const days = Math.floor((now - startDate) / (24 * 60 * 60 * 1000));
  return Math.ceil((now.getDay() + 1 + days) / 7);
};

// ยอดขายจำลองแบบ deterministic (FNV-1a) จาก uid + สัปดาห์ ช่วง 180 - 2,499 ชิ้น
const seededSold = (key, week) => {
  const str = `${key}-w${week}`;
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619) >>> 0;
  }
  return 180 + (h % 2320);
};

export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      data_category: global.category.sort(() => Math.random() - 0.5).slice(0, 4),
      data_top_sale: [],
      data_promotion: [],
      category_can_left: false,
      category_can_right: false,
      top_sale_can_left: false,
      top_sale_can_right: false,
      filter_search: "",
      filter_category: params("category") ? global.category.find(e => e.name === params("category"))?.category_name || "" : "",
      page: params("category") ? 1 : Math.floor(Math.random() * 50) + 1,
      count: Infinity, // กำหนดค่าเริ่มต้นเพื่อให้รอบแรกทำงานได้
      isLoading: false // ใช้เช็คสถานะการโหลด
    };
    // Ref สำหรับแถบหมวดหมู่สินค้า (เลื่อนด้วยปุ่มลูกศร)
    this.categoryRef = React.createRef();
    // Ref สำหรับ carousel ขายดีประจำสัปดาห์ (เลื่อนด้วยปุ่มลูกศรทีละ 6 ชิ้น)
    this.topSaleRef = React.createRef();
    // Ref + ตัวทดสำหรับ carousel สินค้าโปรโมชั่น
    this.promotionRef = React.createRef();
    this.promotionAnimationId = null;
    this.promotionExactScrollLeft = null;
  }

  componentDidMount() {
    const { page } = this.state;
    // เพิ่ม Event Listener จับการเลื่อนหน้าจอ
    window.addEventListener("scroll", this.handleScroll);
    this.GetTopsale();
    this.GetPromotion();
    this.Get(page);
    // คำนวณว่าแถบหมวดหมู่เลื่อนซ้าย/ขวาได้ไหม และคำนวณใหม่เมื่อขนาดจอเปลี่ยน
    this.updateCategoryArrows();
    window.addEventListener("resize", this.updateCategoryArrows);
    window.addEventListener("resize", this.updateTopSaleArrows);
  }

  componentWillUnmount() {
    // ลบ Event Listener ออกเมื่อ Component ถูกทำลาย ป้องกัน Memory Leak
    window.removeEventListener("scroll", this.handleScroll);
    // 2. อย่าลืมเคลียร์ Animation ตอนปิดหน้าเว็บ เพื่อป้องกัน Memory Leak
    window.removeEventListener("resize", this.updateCategoryArrows);
    window.removeEventListener("resize", this.updateTopSaleArrows);
    this.stopPromotionAutoScroll();
  }

  // ฟังก์ชันดักจับการเลื่อนจอ
  handleScroll = () => {
    const { data, isLoading, page, count } = this.state;
    if( data.length >= 120 ) return; // ป้องกันการโหลดข้อมูลเกิน 120 ชิ้น (ประมาณ 5 หน้า) เพื่อประสิทธิภาพที่ดีขึ้น
    // ถ้ากำลังโหลดอยู่ หรือโหลดถึงหน้าสุดท้ายแล้ว ให้หยุดทำงาน
    if (isLoading || page >= count) return;

    // คำนวณความสูง: ถ้าเลื่อนมาจนเหลือระยะห่างจากขอบล่างน้อยกว่า 200px ให้โหลดหน้าถัดไป
    if (
      window.innerHeight + document.documentElement.scrollTop + 200 >= 
      document.documentElement.scrollHeight
    ) {
      this.Get(page + 1);
    }
  };

 GetTopsale = async () => {
    try {
      const count_week = getWeekOfYear();
      // ดึงสินค้าราคาถูกก่อน (ซื้อได้ง่าย) หมุนเวียนหน้าตามสัปดาห์
      const page = ((count_week - 1) % TOP_SALE_ROTATE_PAGES) + 1;

      let [result] = await Promise.all([
        GET("v1/market/products", { page, page_size: TOP_SALE_SIZE, sort: "price_asc" }),
      ]);

      if (result?.status) {
        // ใส่ยอดขายที่ดูสมจริง (ยอดจริงจาก API + ยอดจำลองคงที่ต่อสัปดาห์) แล้วเรียงมากไปน้อย
        const data_top_sale = (result.data || [])
          .map((item) => ({
            ...item,
            display_sold: (Number(item.sold) || 0) + seededSold(item.uid || item.product_code || item.product_name, count_week),
          }))
          .sort((a, b) => b.display_sold - a.display_sold);

        this.setState({ data_top_sale }, () => this.updateTopSaleArrows());
      } else {
        localStorage.clear();
        alert("/", "warning", "แจ้งเตือน", "เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่อีกครั้ง");
      }
    } catch (error) {
      console.error(error);
    }
  };

  // สินค้าโปรโมชั่น: อ่านจาก snapshot ที่ cron คำนวณไว้รายวัน (ตารางเล็ก ไม่กระทบ performance)
  GetPromotion = async () => {
    try {
      const result = await GET("v1/market/products/promotion");
      if (result?.status && Array.isArray(result.data) && result.data.length > 0) {
        this.setState({ data_promotion: result.data }, () => {
          this.startPromotionAutoScroll();
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  Get = async (targetPage = 1) => {
    const { data, filter_search, filter_category } = this.state;
    
    // ป้องกันการยิง API ซ้อนกัน
    if (this.state.isLoading) return;
    this.setState({ isLoading: true });

    let _data = [], count = this.state.count;
    console.log("filter_category", filter_category);
    try {
      let [result] = await Promise.all([
        GET("v1/market/products", { page: targetPage, page_size: count_per_page, data_search: ((filter_category ? filter_category + " " : "") + filter_search).trim() }),
      ]);

      if (result?.status) {
        _data = result.data || [];
        count = Number((result.pagination?.count / count_per_page).toFixed(0));
      } else {
        localStorage.clear();
        alert("/", "warning", "แจ้งเตือน", "เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่อีกครั้ง");
      }

      // จัดการ Data (เหมือนโค้ดเดิมของคุณ)
      const processedData = _data
        .filter(e => !filter_search || e.product_name.toLowerCase().includes(filter_search.toLowerCase()))
        .sort(() => Math.random() - 0.5)
        .filter(e => e.product_image);

      this.setState({
        data: targetPage === 1 ? processedData : [...data, ...processedData], // ถ้าหน้า 1 ให้ทับข้อมูลเดิม
        count,
        page: targetPage,
        isLoading: false // ปิดสถานะโหลดเมื่อเสร็จสิ้น
      });
    } catch (error) {
      console.error(error);
      this.setState({ isLoading: false });
    }
  };

  // ฟังก์ชันวาด Skeleton Card
  renderSkeleton() {
    // สร้าง Dummy Array ไว้ render skeleton 12 ชิ้น (ตามขนาดการแสดงผลที่เหมาะสม)
    return Array.from({ length: 12 }).map((_, index) => (
      <div key={`skeleton-${index}`} className="col-6 col-sm-4 col-md-3 col-xl-2 px-1 mb-2">
        <div className="p-1 bg-light product" style={{ opacity: 0.7 }}>
          <div 
            className="bg-secondary" 
            style={{ inset: 0, margin: "auto", height: "100%", aspectRatio: "1 / 1", opacity: 0.2 }}
          ></div>
          <div className="p-2 placeholder-glow">
            {/* เลียนแบบข้อความชื่อสินค้า */}
            <div style={{ height: "14px", backgroundColor: "#e0e0e0", marginBottom: "4px", borderRadius: "2px", width: "100%" }}></div>
            <div style={{ height: "14px", backgroundColor: "#e0e0e0", marginBottom: "12px", borderRadius: "2px", width: "70%" }}></div>
            
            {/* เลียนแบบราคา */}
            <div style={{ height: "20px", backgroundColor: "#d0d0d0", marginBottom: "12px", borderRadius: "2px", width: "50%" }}></div>
            
            {/* เลียนแบบยอดขาย/ดาว */}
            <div className="d-flex justify-content-between">
              <div style={{ height: "12px", backgroundColor: "#e0e0e0", borderRadius: "2px", width: "40%" }}></div>
              <div style={{ height: "12px", backgroundColor: "#e0e0e0", borderRadius: "2px", width: "30%" }}></div>
            </div>
          </div>
        </div>
      </div>
    ));
  }

  // เช็กว่าแถบหมวดหมู่ยังเลื่อนซ้าย/ขวาได้อีกไหม เพื่อเปิด/ปิดปุ่มลูกศร
  updateCategoryArrows = () => {
    const container = this.categoryRef.current;
    if (!container) return;

    const maxScroll = container.scrollWidth - container.clientWidth;
    const canLeft = container.scrollLeft > 2;
    const canRight = container.scrollLeft < maxScroll - 2;

    if (canLeft !== this.state.category_can_left || canRight !== this.state.category_can_right) {
      this.setState({ category_can_left: canLeft, category_can_right: canRight });
    }
  };

  // เลื่อนแถบหมวดหมู่ทีละ 80% ของความกว้างที่มองเห็น (direction: -1 ซ้าย, 1 ขวา)
  scrollCategory = (direction) => {
    const container = this.categoryRef.current;
    if (!container) return;
    container.scrollBy({ left: direction * container.clientWidth * 0.8, behavior: "smooth" });
  };

  // เช็กว่า carousel ขายดียังเลื่อนซ้าย/ขวาได้อีกไหม เพื่อเปิด/ปิดปุ่มลูกศร
  updateTopSaleArrows = () => {
    const container = this.topSaleRef.current;
    if (!container) return;

    const maxScroll = container.scrollWidth - container.clientWidth;
    const canLeft = container.scrollLeft > 2;
    const canRight = container.scrollLeft < maxScroll - 2;

    if (canLeft !== this.state.top_sale_can_left || canRight !== this.state.top_sale_can_right) {
      this.setState({ top_sale_can_left: canLeft, top_sale_can_right: canRight });
    }
  };

  // เลื่อน carousel ขายดีทีละ TOP_SALE_SCROLL_STEP ชิ้น (direction: -1 ซ้าย, 1 ขวา)
  scrollTopSale = (direction) => {
    const container = this.topSaleRef.current;
    if (!container) return;

    const firstItem = container.firstElementChild;
    const gap = parseFloat(getComputedStyle(container).columnGap) || 12;
    const itemWidth = firstItem ? firstItem.offsetWidth + gap : container.clientWidth / TOP_SALE_SCROLL_STEP;

    container.scrollBy({ left: direction * itemWidth * TOP_SALE_SCROLL_STEP, behavior: "smooth" });
  };

  // ฟังก์ชันเลื่อน carousel สินค้าโปรโมชั่นอัตโนมัติ
  startPromotionAutoScroll = () => {
    const container = this.promotionRef.current;
    if (container) {
      if (this.promotionExactScrollLeft === null) {
        this.promotionExactScrollLeft = container.scrollLeft;
      }

      this.promotionExactScrollLeft += 0.4;
      container.scrollLeft = this.promotionExactScrollLeft;

      if (container.scrollLeft >= container.scrollWidth / 2) {
        container.scrollLeft = 0;
        this.promotionExactScrollLeft = 0;
      }
    }
    this.promotionAnimationId = requestAnimationFrame(this.startPromotionAutoScroll);
  };

  stopPromotionAutoScroll = () => {
    if (this.promotionAnimationId) {
      cancelAnimationFrame(this.promotionAnimationId);
      this.promotionAnimationId = null;
    }
    this.promotionExactScrollLeft = null;
  };

  render() {
    const { data, data_top_sale, data_promotion, data_category, filter_search, isLoading, category_can_left, category_can_right, top_sale_can_left, top_sale_can_right } = this.state;
    const categoryTwoRows = global.category.length > CATEGORY_TWO_ROWS_MIN;
    
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        {/* SECTION 1 - Hero + ค้นหา */}
        <div className="hero-search" style={{ backgroundImage: `url(${HERO_BG})` }}>
          <div className="hero-search-overlay"></div>
          <div className="hero-orb hero-orb-1"></div>
          <div className="hero-orb hero-orb-2"></div>
          <div className="container position-relative">
            <div className="hero-content">
              <h1 className="hero-title">
                ค้นหาสินค้าที่ใช่ <span>ในราคาที่คุ้มค่า</span>
              </h1>
              <p className="hero-subtitle">
                รวมสินค้าหลากหลายหมวดหมู่ คัดสรรคุณภาพ พร้อมติดตามสถานะการสั่งซื้อได้ทุกขั้นตอน
              </p>

              {/* ช่องค้นหา */}
              <div className="hero-search-box">
                <span className="icon hero-search-icon">{"\uf002"}</span>
                <input
                  className="hero-search-input"
                  placeholder="ค้นหาสินค้า แบรนด์ หรือหมวดหมู่..."
                  onChange={e => this.setState({ filter_search: e.target.value })}
                  value={filter_search}
                  onKeyUp={e => {
                    if(e.key === "Enter"){
                      window.location.href = `/product?keyword=${filter_search}`
                    }
                  }}
                />
                <button
                  type="button"
                  className="hero-search-btn"
                  onClick={() => window.location.href = `/product?keyword=${filter_search}`}
                >
                  <span className="icon me-md-2">{"\uf002"}</span>
                  <span className="d-none d-md-inline">ค้นหา</span>
                </button>
              </div>

              {/* หมวดยอดนิยม */}
              <div className="hero-chips">
                <span className="hero-chips-label">ยอดนิยม:</span>
                {data_category.map((item, index) => (
                  <button
                    key={index}
                    type="button"
                    className="hero-chip"
                    onClick={() => window.location.href = `/product?category=${item.name}`}
                  >
                    <span className="icon me-1">{item.icon}</span>{item.name}
                  </button>
                ))}
              </div>
            </div>

          </div>
        </div>

        <div className="w-100 px-1 py-2 p-md-4 min-vh-100">
          
          {/* SECTION 2 - หมวดหมู่สินค้า */}
          <div className="container mb-4">
            <div className="py-3 d-flex align-items-end justify-content-between flex-wrap gap-2">
              <div>
                <h5 className="fw-bold mb-1 category-heading">
                  <span className="icon me-2">{"\uf03a"}</span>หมวดหมู่สินค้า
                </h5>
                <div className="category-heading-line"></div>
              </div>
              <div className="text-muted small">เลือกช้อปตามหมวดหมู่ที่คุณสนใจ</div>
            </div>
            <div className="category-panel rounded-4">
              {/* ปุ่มลูกศรเลื่อนซ้าย/ขวา ปิดปุ่มเมื่อเลื่อนสุดขอบแล้ว */}
              <button
                type="button"
                className="category-arrow category-arrow-left"
                aria-label="เลื่อนหมวดหมู่ไปทางซ้าย"
                disabled={!category_can_left}
                onClick={() => this.scrollCategory(-1)}
              >
                <span className="icon">{"\uf053"}</span>
              </button>
              <button
                type="button"
                className="category-arrow category-arrow-right"
                aria-label="เลื่อนหมวดหมู่ไปทางขวา"
                disabled={!category_can_right}
                onClick={() => this.scrollCategory(1)}
              >
                <span className="icon">{"\uf054"}</span>
              </button>
              <div className="px-2 px-md-3 py-3">
                <div
                  className={`category-scroll-container${categoryTwoRows ? " category-rows-2" : ""}`}
                  ref={this.categoryRef}
                  onScroll={this.updateCategoryArrows}
                >
                  {global.category.map((item, index) => (
                    <div key={`cat-${item.name}-${index}`}>
                      <button 
                        className="btn category-card w-100 h-100 d-flex flex-column align-items-center justify-content-start"
                        onClick={() => window.location.href = `/product?category=${item.name}`}
                      >
                        <div className="category-icon mb-2 d-flex justify-content-center align-items-center">
                          <span className="icon">{item.icon}</span>
                        </div>
                        <div className="category-label">{item.name}</div>
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* SECTION 3 - สินค้าโปรโมชั่น (จากยอดจ่ายยอดนิยม 7 วันล่าสุด) */}
          {data_promotion && data_promotion.length > 0 && (
            <div className="container mb-4">
              <div className="py-3 d-flex align-items-center justify-content-between flex-wrap gap-2">
                <div className="section-title section-title-promo">
                  <div className="section-title-icon">
                    <span className="icon">{"\uf005"}</span>
                  </div>
                  <div>
                    <div className="d-flex align-items-center flex-wrap gap-2">
                      <h4 className="section-title-text mb-0">สินค้าโปรโมชั่น</h4>
                      <span className="section-title-chip"><i></i>ดีลพิเศษ</span>
                    </div>
                    <div className="section-title-sub">คัดจากยอดที่ลูกค้าจ่ายบ่อยที่สุดในสัปดาห์นี้ ซื้อคุ้มได้หลายชิ้น</div>
                  </div>
                </div>
              </div>
              <div className="bg-light rounded-4">
                <div className="p-4 rounded-4">
                  <div
                    className="product-carousel-container p-0"
                    ref={this.promotionRef}
                    onMouseEnter={this.stopPromotionAutoScroll}
                    onMouseLeave={this.startPromotionAutoScroll}
                    onTouchStart={this.stopPromotionAutoScroll}
                    onTouchEnd={this.startPromotionAutoScroll}
                  >
                    {/* เบิ้ล Array 2 รอบ เพื่อให้วนลูปได้เนียน ไร้รอยต่อ */}
                    {[...data_promotion, ...data_promotion].map((item, index) => {
                      const price = Number(item.price) || 0;
                      // โปรชุดจาก cron: จำนวนชิ้น (2/5/10) และราคารวมของชุด
                      const bundleQty = Number(item.quantity) || 1;
                      const bundlePrice = Number(item.bundle_price) || price * bundleQty;
                      const isBundle = bundleQty > 1;

                      return (
                        <a
                          key={`promo-${item.uid || "item"}-${index}`}
                          className="product-carousel-item text-decoration-none text-dark"
                          href={`/product-detail?pd=${item.uid}`}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="p-1 bg-white product rounded-3 shadow-sm h-100">
                            <div className="bg-secondary-light rounded-2 overflow-hidden" style={{ inset: 0, margin: "auto", width: "100%", aspectRatio: "1 / 1", pointerEvents: "none", position: "relative" }}>
                              <img
                                alt="Logo"
                                src={item.product_image || LOGOLARGE}
                                height={"100%"}
                                width={"100%"}
                                style={{ objectFit: "cover" }}
                                onError={(e) => {
                                  e.currentTarget.onerror = null;
                                  e.currentTarget.src = LOGOLARGE;
                                }}
                              />
                              {/* ป้ายดาวโปรโมชั่น มุมบนขวา */}
                              <span className="tag-promo">
                                <span className="icon">{"\uf005"}</span>{isBundle ? `โปร ${bundleQty} ชิ้น` : "PROMO"}
                              </span>
                            </div>
                            <div className="p-2">
                              <div className="overflow-hidden" style={{ lineHeight: 1.2, height: 36 }}>{item.product_name}</div>
                              <h5 className="fw-bold text-orange mb-0">฿{toFixed(bundlePrice, 2)}</h5>
                              <div className="d-flex justify-content-between align-items-center">
                                <small className="text-secondary">
                                  {isBundle ? `${bundleQty} ชิ้น · ฿${toFixed(price, 2)}/ชิ้น` : `ขายได้ ${item.sold || 0} ชิ้น`}
                                </small>
                              </div>
                            </div>
                          </div>
                        </a>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* SECTION 3.5 - ขายดีประจำสัปดาห์ */}
          {data_top_sale && data_top_sale.length > 0 && (
            <div className="container mb-4">
              <div className="py-3 d-flex align-items-center justify-content-between flex-wrap gap-2">
                <div className="section-title section-title-hot">
                  <div className="section-title-icon">
                    <span className="icon">{"\uf06d"}</span>
                  </div>
                  <div>
                    <div className="d-flex align-items-center flex-wrap gap-2">
                      <h4 className="section-title-text mb-0">ขายดีประจำสัปดาห์</h4>
                      <span className="section-title-chip"><i></i>HOT</span>
                    </div>
                    <div className="section-title-sub">อันดับสินค้าที่ลูกค้าซื้อมากที่สุด อัปเดตทุกสัปดาห์</div>
                  </div>
                </div>
              </div>
              <div className="bg-light rounded-4 position-relative">
                {/* ปุ่มลูกศรเลื่อนซ้าย/ขวา ทีละ 6 ชิ้น ปิดปุ่มเมื่อสุดขอบ */}
                <button
                  type="button"
                  className="category-arrow category-arrow-left"
                  aria-label="เลื่อนสินค้าขายดีไปทางซ้าย"
                  disabled={!top_sale_can_left}
                  onClick={() => this.scrollTopSale(-1)}
                >
                  <span className="icon">{"\uf053"}</span>
                </button>
                <button
                  type="button"
                  className="category-arrow category-arrow-right"
                  aria-label="เลื่อนสินค้าขายดีไปทางขวา"
                  disabled={!top_sale_can_right}
                  onClick={() => this.scrollTopSale(1)}
                >
                  <span className="icon">{"\uf054"}</span>
                </button>
                <div className="p-4 rounded-4">
                  <div
                    className="product-carousel-container p-0"
                    ref={this.topSaleRef}
                    onScroll={this.updateTopSaleArrows}
                  >
                    {data_top_sale.map((item, index) => {
                      const itemSold = Number(item.display_sold ?? item.sold) || 0;

                      return (
                        <a 
                          key={`top-${item.uid || "item"}-${index}`} 
                          className="product-carousel-item text-decoration-none text-dark"
                          href={`/product-detail?pd=${item.uid}`}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className="p-1 bg-white product rounded-3 shadow-sm h-100">
                            <div className="bg-secondary-light rounded-2 overflow-hidden" style={{ inset: 0, margin: "auto", width: "100%", aspectRatio: "1 / 1", pointerEvents: "none", position: "relative" }}>
                              <img 
                                alt="Logo" 
                                src={item.product_image || LOGOLARGE} 
                                height={"100%"} 
                                width={"100%"} 
                                style={{ objectFit: "cover" }} 
                                onError={(e) => {
                                  e.currentTarget.onerror = null;
                                  e.currentTarget.src = LOGOLARGE;
                                }}
                              />
                              {/* ธงคาดมุมบนซ้าย */}
                              <div className="ribbon-top-sale"><span>TOP SALE</span></div>
                            </div>
                            <div className="p-2">
                              <div className="overflow-hidden" style={{ lineHeight: 1.2, height: 36 }}>{item.product_name}</div>
                              <h5 className="fw-bold text-orange">฿{toFixed(Number(item.price), 2)}</h5>
                              <div className="d-flex justify-content-between align-items-center">
                                <small className="text-secondary">ขายแล้ว {itemSold.toLocaleString("en-US")} ชิ้น</small>
                                <small className="fw-semibold text-danger">#{index + 1}</small>
                              </div>
                            </div>
                          </div>
                        </a>
                      );
                    })}

                  </div>
                </div>
              </div>
            </div>
          )}

          {/* SECTION 4 - รายการสินค้า */}
          <div className="container">
             <div className="py-3">
                  <h5 className="fw-bold mb-0">
                    <span className="icon me-2">{"\uf03a"}</span>สินค้าแนะนำ
                  </h5>
                </div>
            <div className="row mb-4">
              
              {/* แสดงข้อมูลสินค้าที่มีอยู่ */}
              {data.map((item, index) => (
                <a 
                  key={item.uid || index} 
                  className="col-6 col-sm-4 col-md-3 col-xl-2 px-1 mb-2 text-decoration-none text-dark" 
                  href = {`/product-detail?pd=${item.uid}`}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="p-1 bg-light product">
                    <div className="bg-secondary-light" style={{ inset: 0, margin: "auto", height: "100%", aspectRatio: "1 / 1", pointerEvents: "none", position: "relative" }}>
                      <img 
                        alt="Logo" 
                        src={item.product_image || LOGOLARGE} 
                        height={"100%"} 
                        width={"100%"} 
                        style={{ objectFit: "cover" }} 
                        onError={(e) => {
                          e.currentTarget.onerror = null;
                          e.currentTarget.src = LOGOLARGE;
                        }}
                      />
                    </div>
                    <div className="p-2">
                      <div className="overflow-hidden" style={{ lineHeight: 1.2, height: 36 }}>{item.product_name}</div>
                      <h5 className="fw-bold">฿{toFixed(Number(item.price), 2)}</h5>
                      <div className="d-flex justify-content-between">
                        <small className="text-secondary">ขายได้ {item.sold} ชิ้น</small>
                        
                      </div>
                    </div>
                  </div>
                </a>
              ))}

              {/* แสดง Skeleton ตอนที่กำลังโหลดข้อมูล (ต่อท้ายรายการเดิม) */}
              {isLoading && this.renderSkeleton()}

            </div>
            
            {/* นำปุ่ม "เพิ่มเติม" ออกไปแล้ว เพราะใช้เลื่อนหน้าจอแทน */}
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}